// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Router
import { Redirect } from 'react-router-dom';

// MainStore
import { MainStore } from '../stores/MainStore';

// Managers
import { NetworkManager } from '../managers/NetworkManager';

// Framework
import { getURLByEnv } from '../framework/utils/URL';

// Components
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

interface State {
  errors: Array<any>;
  errorText: string;
  rememberMe: boolean;
  password: string;
  username: string;
}

interface Props {
  match: any;
  location: any;
  navigation: any;
  user: any;
}

/**
 * @description Login View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Login extends React.Component<Props, State> {

  /**
   * Creates an instance of Login.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      errors: [],
      errorText: "",
      password: "",
      rememberMe: false,
      username: ""
    };
  }

  componentDidMount() {
    document.title = "Gigon SA | Connexion";
  }

  checkUserValues = async (event: any) => {
    const errors: any = [];
    let connection = true;

    if (this.state.username == "") {
      errors['username'] = "Nom d'utilisateur vide";
      connection = false;
    }
    if (this.state.password == "") {
      errors['password'] = "Mot de passe vide";
      connection = false;
    }

    if (connection) {
      MainStore.showOverlay("Connexion en cours...");
      const result = await NetworkManager.connect(this.state.username, this.state.password, this.state.rememberMe);
      MainStore.hideOverlay();

      if (result != true) {
        this.setState({
          errorText: result.error
        });
      } else {
        MainStore.updateActualView(`${getURLByEnv()}/`);
        this.setState({
          errorText: ""
        });
      }
    }

    this.setState({ errors: errors });
  }

  handleChangeRememberMe = () => {
    this.setState((prevState: State) => {
      return {
        rememberMe: !prevState.rememberMe
      };
    });
  }

  catchReturn = (event: any) => {
    if (event.key === 'Enter') {
      this.checkUserValues(event);
    }
  }

  /**
   * @description Render the LoginView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    if (this.props.user.connected) {
      return (<Redirect to={`${getURLByEnv()}/`} />);
    }
    return (
      <Paper elevation={1} className="form-paper-container login" style={{ marginTop: 24 }}>
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>person</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          Connexion
        </Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} className="form-field">
            <TextField
              label="Nom d'utilisateur"
              name="username"
              defaultValue=""
              error={Boolean(this.state.errors['username'])}
              helperText={this.state.errors['username']}
              fullWidth={true}
              onChange={(e) => { this.setState({ username: e.target.value }); }}
            />
          </Grid>
          <Grid item={true} xs={12} className="form-field">
            <TextField
              label="Mot de passe"
              type="password"
              id="password"
              defaultValue=""
              error={Boolean(this.state.errors['password'])}
              helperText={this.state.errors['password']}
              fullWidth={true}
              onKeyPress={this.catchReturn}
              onChange={(e) => { this.setState({ password: e.target.value }); }}
            />
          </Grid>
          <Grid item={true} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={this.state.rememberMe}
                  onChange={this.handleChangeRememberMe}
                  value={this.state.rememberMe.toString()}
                />
              }
              label="Se souvenir de moi"
            />
          </Grid>
          {this.state.errorText.length > 0 &&
            <Grid item={true} xs={12}>
              <Typography align="center" color="error">{this.state.errorText}</Typography>
            </Grid>
          }
        </Grid>
        <div className="btn-center">
          <Button variant="contained" className="button-add square btn-center" onClick={this.checkUserValues}>
            Se connecter
          </Button>
        </div>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Login.tsx